// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AssignClassesToDescendantsController from "./assign_classes_to_descendants_controller"
application.register("assign-classes-to-descendants", AssignClassesToDescendantsController)

import BemerkungenController from "./bemerkungen_controller"
application.register("bemerkungen", BemerkungenController)

import CheckboxTooltipController from "./checkbox_tooltip_controller"
application.register("checkbox-tooltip", CheckboxTooltipController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import CollapsibleExpandableController from "./collapsible_expandable_controller"
application.register("collapsible-expandable", CollapsibleExpandableController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ContactModalController from "./contact_modal_controller"
application.register("contact-modal", ContactModalController)

import ContextMenuController from "./context_menu_controller"
application.register("context-menu", ContextMenuController)

import CustomQuestionChangeGuardController from "./custom_question_change_guard_controller"
application.register("custom-question-change-guard", CustomQuestionChangeGuardController)

import DatenschutzerklaerungController from "./datenschutzerklaerung_controller"
application.register("datenschutzerklaerung", DatenschutzerklaerungController)

import DatenschutzerklaerungRemoveConsentController from "./datenschutzerklaerung_remove_consent_controller"
application.register("datenschutzerklaerung-remove-consent", DatenschutzerklaerungRemoveConsentController)

import DatenschutzerklaerungSetConsentController from "./datenschutzerklaerung_set_consent_controller"
application.register("datenschutzerklaerung-set-consent", DatenschutzerklaerungSetConsentController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DatepickerOnModalController from "./datepicker_on_modal_controller"
application.register("datepicker-on-modal", DatepickerOnModalController)

import DisableAfterClickController from "./disable_after_click_controller"
application.register("disable-after-click", DisableAfterClickController)

import DragController from "./drag_controller"
application.register("drag", DragController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DropdownTriggerController from "./dropdown_trigger_controller"
application.register("dropdown-trigger", DropdownTriggerController)

import EllipsisTooltipController from "./ellipsis_tooltip_controller"
application.register("ellipsis-tooltip", EllipsisTooltipController)

import ExpandableListController from "./expandable_list_controller"
application.register("expandable-list", ExpandableListController)

import FormController from "./form_controller"
application.register("form", FormController)

import FreigabeButtonsetController from "./freigabe_buttonset_controller"
application.register("freigabe-buttonset", FreigabeButtonsetController)

import FreigabeCheckboxSetController from "./freigabe_checkbox_set_controller"
application.register("freigabe-checkbox-set", FreigabeCheckboxSetController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import InvitationFormController from "./invitation_form_controller"
application.register("invitation-form", InvitationFormController)

import LandingpageController from "./landingpage_controller"
application.register("landingpage", LandingpageController)

import LinkedDatalistController from "./linked_datalist_controller"
application.register("linked-datalist", LinkedDatalistController)

import MDropdownTurboFetchController from "./m_dropdown_turbo_fetch_controller"
application.register("m-dropdown-turbo-fetch", MDropdownTurboFetchController)

import MaterializeTextareaController from "./materialize_textarea_controller"
application.register("materialize-textarea", MaterializeTextareaController)

import MaterializecssInitController from "./materializecss_init_controller"
application.register("materializecss-init", MaterializecssInitController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalForTurboController from "./modal_for_turbo_controller"
application.register("modal-for-turbo", ModalForTurboController)

import ModalWithoutAnimationController from "./modal_without_animation_controller"
application.register("modal-without-animation", ModalWithoutAnimationController)

import NoContextMenuController from "./no_context_menu_controller"
application.register("no-context-menu", NoContextMenuController)

import NoCurrentEntryContractController from "./no_current_entry_contract_controller"
application.register("no-current-entry-contract", NoCurrentEntryContractController)

import NoPropagationController from "./no_propagation_controller"
application.register("no-propagation", NoPropagationController)

import PersonSurveyBaseController from "./person_survey_base_controller"
application.register("person-survey-base", PersonSurveyBaseController)

import PersonSurveyController from "./person_survey_controller"
application.register("person-survey", PersonSurveyController)

import PersonSurveySlController from "./person_survey_sl_controller"
application.register("person-survey-sl", PersonSurveySlController)

import PersonSurveyTimeTableController from "./person_survey_time_table_controller"
application.register("person-survey-time-table", PersonSurveyTimeTableController)

import PuCustomQuestionOptionListController from "./pu_custom_question_option_list_controller"
application.register("pu-custom-question-option-list", PuCustomQuestionOptionListController)

import RebindMatchLinksController from "./rebind_match_links_controller"
application.register("rebind-match-links", RebindMatchLinksController)

import ReciprocalRemoveClassController from "./reciprocal_remove_class_controller"
application.register("reciprocal-remove-class", ReciprocalRemoveClassController)

import RemoteContentController from "./remote_content_controller"
application.register("remote-content", RemoteContentController)

import RemoteLinkController from "./remote_link_controller"
application.register("remote-link", RemoteLinkController)

import RemoveClassOnClickOutsideController from "./remove_class_on_click_outside_controller"
application.register("remove-class-on-click-outside", RemoveClassOnClickOutsideController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ScrollToHighlightController from "./scroll_to_highlight_controller"
application.register("scroll-to-highlight", ScrollToHighlightController)

import ScrollToRecordController from "./scroll_to_record_controller"
application.register("scroll-to-record", ScrollToRecordController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import ShowSchuleInfoController from "./show_schule_info_controller"
application.register("show-schule-info", ShowSchuleInfoController)

import SurveyPreviewStepNavController from "./survey_preview_step_nav_controller"
application.register("survey-preview-step-nav", SurveyPreviewStepNavController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleByRadioButtonController from "./toggle_by_radio_button_controller"
application.register("toggle-by-radio-button", ToggleByRadioButtonController)

import ToggleBySelectOptionController from "./toggle_by_select_option_controller"
application.register("toggle-by-select-option", ToggleBySelectOptionController)

import ToggleClassOnClickController from "./toggle_class_on_click_controller"
application.register("toggle-class-on-click", ToggleClassOnClickController)

import ToggleVonBisFieldsController from "./toggle_von_bis_fields_controller"
application.register("toggle-von-bis-fields", ToggleVonBisFieldsController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TurboFetchController from "./turbo_fetch_controller"
application.register("turbo-fetch", TurboFetchController)

import TurboFrameController from "./turbo_frame_controller"
application.register("turbo-frame", TurboFrameController)

import UserSchulePeopleFormController from "./user_schule_people_form_controller"
application.register("user-schule-people-form", UserSchulePeopleFormController)
